import {
  Component,
  Output,
  EventEmitter } from '@angular/core';
import { FlowManagerService } from '../../shared/services/flowmanager.service';

@Component({
  selector: 'funding-footer',
  template: require('./fundingFooter.component.html')
})
export class FundingFooterComponent {
  @Output() btnClickEmitter = new EventEmitter();
  @Output() difFundingEmitter = new EventEmitter();

  constructor(flowManager: FlowManagerService) {
    this.flowManager = flowManager;
  }

  ngOnInit() {
    this.isAuthed = this.flowManager.isAuthed;
  }

  difFundingMethod(event) {
    this.difFundingEmitter.emit(event);
  }

  btnClick(event) {
    this.btnClickEmitter.emit(event);
  }
}
